import { useRef, useState, useEffect } from "react";
import { useScroll, useTransform } from "framer-motion";

import Image from "components/base/Image";
import Text from "components/base/Text";
import Trans from "components/base/Trans";

import {
  MotionBox as Box,
  MotionGrid as Grid,
  staggeredAppear,
  appearBelow,
} from "utils/motion";

export default function VerticalImageSection() {
  const scrollRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: scrollRef,
    offset: ["start end", "end start"],
  });

  const gridRef = useRef(null);
  const [gridHeight, setGridHeight] = useState(0);

  useEffect(() => {
    if (gridRef.current) {
      setGridHeight(gridRef.current.offsetHeight);
    }
  }, []);

  const imageY = useTransform(scrollYProgress, [0, 1], [0, gridHeight - 800]);
  const opacity = useTransform(scrollYProgress, [0, 0.2, 1], [0, 0.5, 1]);

  return (
    <Box width="100%" bg="black.900" style={{ overflow: "hidden" }}>
      <Grid
        ref={gridRef}
        width="100%"
        templateColumns={["1fr", null, "0.7fr 1fr"]}
        position="relative"
      >
        {/* Image column */}
        <Box style={{ y: imageY }} height={["100vh", null, "800px"]}>
          <Image
            height="100%"
            width="100%"
            objectFit="contain"
            src="/images/ga/img-vertical-top.jpg"
          />
          <Box
            height="100%"
            width="100%"
            position="absolute"
            display={["block", null, "none"]}
            top={0}
            left={0}
            bg="black.900"
            style={{ opacity: opacity }}
          />
        </Box>

        <Box
          ref={scrollRef}
          mr={[0, null, 24]}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          pt={[16, null, 32]}
          pb={[16, null, 32]}
          px={[6, null, 16]}
          zIndex={1}
          position="relative"
        >
          <Text
            type="headline_md"
            variants={appearBelow}
            mb={[1, null, 2]}
            color="white"
          >
            <Trans id="LBL_GA2_CERTIFICATION_TITLE" />
          </Text>

          <Text
            type="p_md"
            variants={appearBelow}
            lineHeight="32px"
            pt={[4, null, 8]}
            color="white"
          >
            <Trans id="LBL_GA2_CERTIFICATION_DESCRIPTION" />
          </Text>
        </Box>
      </Grid>
    </Box>
  );
}
